<div>
  <label class="sm-label">{{'_General_Reason_Text_' | translate }}</label>
  <select>
    <option>{{'_Shared_App_SignOut_opt_Lunch_Text_' | translate }}</option>
    <option>{{'_Shared_App_SignOut_opt_Outstation_Text_' | translate }}</option>
    <option>{{'_Shared_App_SignOut_opt_Something_Text_' | translate }}</option>
  </select>
</div>
<div>
  <label class="sm-label">{{'_General_Report_Comments_Text_' | translate }}</label>
  <textarea maxlength="150" placeholder="" rows="5"></textarea>
</div>